import $ from 'jquery'

$(document).ready(function() {
  co_vc_stage()
})

function co_vc_stage() {
  $('.co_vc_stage').each(function() {})
}
